module.exports = __webpack_public_path__ + "static/WEDDING E&M-454-9f845a5e5f797d2bbc2271cf4d194d3d.jpg";